import React, { useState } from 'react';
import BulkRebalancingModal from './BulkRebalancingModal';
import './BulkBuyAndSellModal.scss';
import { FaShare } from 'react-icons/fa';
import { useNotify } from '@features/Notify';
import { createBulkTradeOrder } from '@pages/Preferences/api';
import { ShareButton } from '../OrderConfirmDialog/OrderConfirmDialog';
import { ReactComponent as BarsIcon } from '../../../../shared/assets/svgs/BarsIcon.svg';

export const BulkBuySellAdjustmentModal: React.FC = () => {
    const [getTableData, setGetTableData] = useState<() => any[]>(() => () => []);
    const [hasShared, setHasShared] = useState(false);
    const [isSharing, setIsSharing] = useState(false);
    const notify = useNotify();
    const handleShareClick = async () => {
        const currentData = getTableData();
        if (currentData.length > 0) {
            setIsSharing(true);
            const jobIdSet = new Set<number>();

            currentData.forEach((entry) => {
                entry.rebalancingReports.forEach((report: any) => {
                    jobIdSet.add(report.jobId);
                });
            });

            // Step 2: Convert Set to array of trade order objects
            const tradeOrders = Array.from(jobIdSet).map((jobId) => ({
                jobId,
                tradeOrderStatus: 'Pending',
            }));

            try {
                const result = await createBulkTradeOrder(tradeOrders);
                setHasShared(true);
                notify.success(result);
            } catch (error) {
                notify.error('Error creating trade orders.');
            } finally {
                setIsSharing(false); // Set loading to false when done
            }
        }
    };
    return (
        <div className='widget-bulk-rebalancing-table-modal'>
            <div className='widget-bulk-rebalancing-table-modal__header'>
                <BarsIcon />
                <div className='widget-bulk-header'>
                    <div className='widget-bulk-rebalancing-table-modal__title'>Determine Buy/Sell Adjustments </div>
                    <ShareButton
                        onShare={handleShareClick}
                        disabled={!getTableData || getTableData().length === 0}
                        hasShared={hasShared}
                        loading={isSharing}
                    />
                </div>
            </div>

            <div className='widget-bulk-rebalancing-table-modal__content'>
                <BulkRebalancingModal setDataGetter={setGetTableData} />
            </div>
        </div>
    );
};
